import { hasLanguage } from 'ha/helpers/routes/hasLanguage';
import NotFoundPage from 'ha/pages/NotFound';

export default (getComponentsWithNotFound, pageName = 'Home') => (
  location,
  cbLang,
) => {
  if (hasLanguage(location)) {
    return cbLang(null, {
      getComponents: getComponentsWithNotFound(pageName),
    });
  }

  return cbLang(null, {
    component: NotFoundPage,
  });
};
